import { number, checkPropTypes } from 'prop-types';

var limitChildren = function limitChildren(props, propName, componentName) {
  var _checkPropTypes;

  var children = props.children,
      activeStep = props[propName];
  checkPropTypes((_checkPropTypes = {}, _checkPropTypes[propName] = number, _checkPropTypes), props, 'prop', componentName);

  if (activeStep > children.length - 1) {
    return new Error("Invalid prop \"" + propName + "\" supplied to \"" + componentName + "\". \"" + propName + "\" must be smaller or equal the number of children.");
  }

  return null;
};

export default limitChildren;